import { Route, Switch, withRouter } from 'react-router-dom';
import DonorConnect from '@nkr/views/dash/donor-connect';
import DonorConnectMentorPerformance from '@nkr/views/admin/donorconnect-mentor-performance';
import DonorConnectUserCaseLoadLimits from '@nkr/views/dash/donor-connect/user-case-load-limits';
import DonorConnectIncidentReports from '@nkr/views/dash/donor-connect/incident-report';
import DonorConnectCompletions from '@nkr/views/dash/donor-connect/reports/completions';

const DonorConnectRoutes = (params) => {
    let url = params.url;

    return (
        <Switch>
            <Route path={`${url}/incident-report`} component={DonorConnectIncidentReports} />
            <Route path={`${url}/report/completions`} component={DonorConnectCompletions} />
            <Route path={`${url}/report/donor-connect-mentor-performance`} component={DonorConnectMentorPerformance} />
            <Route path={`${url}/user-case-load-limits`} component={DonorConnectUserCaseLoadLimits} />
            <Route path={`${url}/unassigned`} component={DonorConnect} />
            <Route path={`${url}/to-do`} component={DonorConnect} />
            <Route path={`${url}/assigned-to-me`} component={DonorConnect} />
            <Route path={`${url}/all`} component={DonorConnect} />
            <Route path={`${url}/`} component={DonorConnect} />
        </Switch>
    );
}

export default withRouter(DonorConnectRoutes);